/* eslint react/jsx-handler-names:0 */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, propTypes, formValueSelector } from 'redux-form';
import { checkRole, isEmpty } from '../../utils/functions';
import ContentWrapper from "../../components/layout/ContentWrapper";
import Wizard from '../../components/common/wizard';
import { fetchPostEvent, resetPostEventWizard, fetchActiveSeasons } from "../../redux/actions/action_postEvent";
import {  setUserRole } from "../../redux/actions/action_user";
import '../../utils/css/nospinner.css';
import { posteventdefaults } from '../../utils/constants';
import { StepActions } from '../../components/common/wizard/logic';
import logo from "../../images/star-fade.gif";
import userManager from '../../userManager';
import SearchBar from './components/searchbar';
import SearchResults from './components/searchresults';
import { goToStep, getSteps, getWizardComponent } from "./logic";
  
const formName = 'postevent'
 
class PostEvent extends Component {
		
	static propTypes = {
		...propTypes
	}
	constructor(props)
	{
		super(props);   
		this.state = {
			showSearchResultsMode: false,
			searchResults:[],
			wizardsteps:null,
			component:null,
			saveComponentState:false,
			wizardMode:false,
			stepsSet: false,
		};
		this.refreshEventWizard = this.refreshEventWizard.bind(this);		
		this.applyPermission =  this.applyPermission.bind(this);
		this.handleNextStep = this.handleNextStep.bind(this);
		this.handlePreviousStep = this.handlePreviousStep.bind(this);
		this.handleGoToStep = 	this.handleGoToStep.bind(this);
		this.handleOnComponentStateSaved = this.handleOnComponentStateSaved.bind(this);
		this.handleViewEventDetails = this.handleViewEventDetails.bind(this);
		this.setWizardSteps = this.setWizardSteps.bind(this);
		this.clearWizardMode = this.clearWizardMode.bind(this);
		this.onHandleSearchResults = this.onHandleSearchResults.bind(this);
		this.handleSearchCriteriaChange = this.handleSearchCriteriaChange.bind(this);
		this.onHandleSearchByChange = this.onHandleSearchByChange.bind(this);
	}

	componentDidMount() {
		const { oidc } = this.props;
		const _this = this;
		const { fetchActiveSeasons } = this.props;

		if (oidc.user == null)
		{
			userManager.signinRedirect().then(function() {
				_this.applyPermission();
			});
		}
		else
		{
			this.props.dispatch(fetchActiveSeasons());
		}
	} 
	
	componentWillReceiveProps = (nextProps)=> {
		if (nextProps.location.key !== this.props.location.key) 
		{
			this.setState(
			{
				searchResults:[],
				showSearchResultsMode:false,
			});
			this.props.dispatch(resetPostEventWizard());
		}
	}
	
	applyPermission()
	{
		const { user } = this.props.oidc;
		const { roleChecked } = this.props.user;
		const { dispatch } = this.props;
	
		if ((user !== null) && (roleChecked === false))
		{
			const token = user.access_token;
			checkRole(token).then(function(response) {
				const roleName = response.data.roleName;
				dispatch(setUserRole(roleName));
			})
		}
	}

	onHandleSearchResults(searchResults) {
		this.setState({
			searchResults: searchResults,
			showSearchResultsMode:true
		})
	}

	handleSearchCriteriaChange() {
		this.setState({
			showSearchResultsMode:false,
			searchResults:[]
		})
	}

	refreshEventWizard(updatedSteps)
	{
		const { steps, next } = updatedSteps;
		const component = getWizardComponent(next);
		this.setState({
			wizardsteps:steps,
			component,
		});
	}

	handleNextStep() {
		this.setState({ saveComponentState:true });
	}

	handlePreviousStep() {
		const { wizardsteps } = this.state;
		const updatedSteps = goToStep(StepActions.Previous,wizardsteps);
		this.refreshEventWizard(updatedSteps);
	}

	handleGoToStep(step) {
		const { wizardsteps } = this.state;
		const updatedSteps = goToStep(StepActions.GoTo,wizardsteps,step);
		this.refreshEventWizard(updatedSteps);
	}

	handleOnComponentStateSaved(saved) {
		if(saved === true)
		{
			const { wizardsteps } = this.state;
			const updatedSteps = goToStep(StepActions.Next,wizardsteps);
			this.refreshEventWizard(updatedSteps);
		}
		this.setState({ saveComponentState:false })
	}

	handleViewEventDetails(eventId){
		this.props.dispatch(resetPostEventWizard());
		this.props.dispatch(fetchPostEvent(eventId));
		this.props.history.push('/postevent');
		this.setState({
			showSearchResultsMode:false,
		});
	}

 setWizardSteps()
 {
	const { stepsSet } = this.state;
	const {
		currentWizardStep,
		lastStepCompleted,
	} = this.props;
	
	if(!stepsSet)
	{
		const { wizardsteps } = getSteps(currentWizardStep,lastStepCompleted);
		
		const component = getWizardComponent(currentWizardStep);
 
		this.setState({
			wizardMode:true,
			showSearchResultsMode:false,
			wizardsteps,
			component,
			stepsSet: true,
		})
	}
 }
 clearWizardMode()
 {
	this.setState({
		wizardMode:false,
		showSearchResultsMode:false,
		stepsSet:false,
		wizardsteps:null,
	});
 }

 onHandleSearchByChange() {
	this.setState({ searchResults:[], showSearchResultsMode: false, });
}

 render()
 {
	const {
		oidc,
		eventId,
		eventRetrieved,
		fetchingevent
	} = this.props;

	const {
		wizardMode,
		searchResults,
		wizardsteps,
		component,
		saveComponentState,
		showSearchResultsMode,
	} = this.state;
 
	const  token =  isEmpty(oidc.user) === false ? oidc.user.access_token: '';
	const  fromSidebar  = this.props.location.state !== undefined ? this.props.location.state.fromSidebar : false;
	const showWizard = ((eventId > 0 && eventRetrieved) || (wizardMode)) && (fromSidebar === false);
	
	if(showWizard)
	{
		this.setWizardSteps();
	}

	const { roleName } = this.props.user;
	const isAdministrator = roleName === 'Administrator'
	
	this.applyPermission();
 
	return (
		<ContentWrapper style={{ minHeight:'1850px' }}>
			<div className="content-heading" style={{ marginBottom:'30px' }}>
				Post Event Management
			</div>
			{ 
				!wizardMode && 
				(<SearchBar
					token={token}
					OnSearchResults={this.onHandleSearchResults} 
					onSearchCriteriaChange={this.handleSearchCriteriaChange} 
					SearchByChange={this.onHandleSearchByChange}
					isAdministrator={isAdministrator}
				/>)
			} 
			{ 
				showSearchResultsMode && 
				(<SearchResults
					formName = {formName} 
					searchResults = {searchResults}
					onViewEventDetails={this.handleViewEventDetails}
				/>)
			}
			{
				fetchingevent &&
				<div sm={12} style={{ backgroundImage:`url(${logo})`,backgroundRepeat:'no-repeat',height:'400px',width:'400px',margin:'0 auto' }} />
			} 
			{
				showWizard && !isEmpty(wizardsteps) && !fetchingevent &&
				(<Wizard steps={wizardsteps}
					component={component}
					saveComponentState={saveComponentState} 
					resetSaveComponentState = {this.handleResetSaveComponentState}
					onNext={this.handleNextStep}
					onPrevious={this.handlePreviousStep}
					onGoTo={this.handleGoToStep}
					onComponentStateSaved={this.handleOnComponentStateSaved} 
					onUnmount={this.clearWizardMode}
				/>)
			}
		</ContentWrapper>        
	)
	}
 }
 PostEvent.propTypes = {
	dispatch: PropTypes.func,
	fetchPostEvent: PropTypes.func,
	oidc: PropTypes.object,
	user: PropTypes.object,
	fetchingevent: PropTypes.bool,
	eventRetrieved: PropTypes.bool,
	eventId: PropTypes.number,
	currentWizardStep: PropTypes.number,
	lastStepCompleted: PropTypes.number,
	resetPostEventWizard: PropTypes.func,
	fetchActiveSeasons: PropTypes.func,
	location: PropTypes.object,
	history: PropTypes.object,
	setUserRole: PropTypes.func
 }
 function mapStateToProps(state,ownProps){
	const formName          =  ownProps.form;
	const selector          = formValueSelector(formName);
	const eventId           = selector(state,'eventId');
	const eventRetrieved    = selector(state,'eventRetrieved');
	const currentWizardStep = selector(state,'currentWizardStep');
	const lastStepCompleted = selector(state,'lastStepCompleted');
	const fetchingevent     = selector(state,'fetchingevent');
	return {
		oidc: { ...state.oidc },
		user:{ ...state.user },
		eventId,
		eventRetrieved,
		currentWizardStep,
		lastStepCompleted,
		fetchingevent
	};
 }
 function mapDispatchToProps(dispatch){
	return bindActionCreators({
			fetchPostEvent,
			resetPostEventWizard,
			fetchActiveSeasons,
			setUserRole
		},dispatch)
 }
 export default reduxForm({
	form:formName,
	destroyOnUnmount: false,
	initialValues:posteventdefaults,
 })(connect(mapStateToProps,mapDispatchToProps)(PostEvent))
 
 


// WEBPACK FOOTER //
// ./src/containers/postevent/index.js